<div class="edit-block mat-elevation-z1">
    <h2>{{ 'Rest' | translate }}</h2>

    <duration-control
                      [(value)]="data.data.restTime"
                      [label]="'restTimePlaceholder' | translate"
                      [displayMode]="'ms'"
                      (change)="onRestTimeChange()">
    </duration-control>
</div>
